import React, { Component } from 'react';
import $ from 'jquery';
import { Link ,browserHistory} from 'react-router';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';
export default class verifyOtp extends Component {
	constructor(props,context){
		super(props);
		this.state={
			mobile: localStorage.getItem('mobile_number'),
			invalid_otp: '',
		}
		this.handleSubmit = this.handleSubmit.bind(this);
		this.gotoLogin= this.gotoLogin.bind(this);
		this.resendOtp = this.resendOtp.bind(this);
	}
	componentDidMount(){
		this.refs.otp.focus();
	}
	resendOtp(){

		var data1= {from:'mobile_web',mobile: this.state.mobile};
		var data2= JSON.stringify(data1);
		$.ajax({
			method: 'POST',
			url: baseUrl+'resendOtp',
			data: {req:data2},
			dataType: 'json',
			success: function(data){
			},
			error: function(err){
				
			}
		});
	}
	handleSubmit(event){
		event.preventDefault();
		var data1= {from: 'mobile_web',mobile: localStorage.getItem('mobile_number'),otp: this.refs.otp.value};
		var data2 = JSON.stringify(data1);
		$.ajax({
			method: 'POST',
			url: baseUrl+'verifyforgotOtp',
			data: {req:data2},
			dataType: 'json',
			success: function(data){
				if(data.status === "success"){
					browserHistory.push('/reset');
				}
				if(data.status==='fail'){
					this.setState({
						err:true,
						invalid_otp: 'Invalid Otp',
					});
				}
			}.bind(this),
			error: function(err){
			}
		})
	}
	gotoLogin(event){
		event.preventDefault();
		browserHistory.push('/login');
	}
	
	render(){
	return(
		    <div className="user_form">
		        <Link onClick={()=>{browserHistory.goBack()}} className="back_icon"><i><img src={baseAssets+'images/web_imgs/back_arrow.png'} width="18px" alt=" " /></i></Link>
		         <div className="container pag_cntnt">
			        <div className="row" style={{marginLeft:'0',marginRight:'0'}}>
			          <h5 className="sign_in_title">Verify Your Mobile Number</h5>
			          <span className="otp_number">OTP sent to {'+91 '+this.state.mobile}</span>
			          <form className="text-center otp_form" onSubmit={this.handleSubmit}>
				         <div className='reg_group'>
			                <input type="text" ref="otp" maxLength={6} required placeholder="Enter OTP" />
		      			    <span className="highlight"></span>
							<span className="bar"></span>
							{this.state.err ? this.state.invalid_otp : ''}   
				         </div>
				         <div className="clr">&nbsp;</div>
				         <button action="submit" className="btn mob_regbtn">ENTER</button>
			             <div className="clr">&nbsp;</div>
			              <div className="tap" >
		               		<a style={{cursor:'pointer'}} onClick={this.resendOtp}>RESEND OTP</a>
		                  </div>
			          </form>
			        </div>
		         </div>
		   </div>
		);  
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Auth/verifyOtp.js
 **/